<script setup lang="ts">
const { isActive = false, size = 1.5 } = defineProps<{
  isActive?: boolean
  size?: number
}>()
</script>

<template>
  <div class="align-middle">
    <BaseIcon
      :class="[
        'cursor-pointer',
        {
          'animate-[clicked_0.12s_ease-in-out] fill-primary-500 text-primary-500':
            isActive,
        },
        { 'duration-300 hover:fill-gray-200': !isActive },
      ]"
      :size="size"
      aria-hidden="true"
      focusable="false"
      name="heart"
    />
  </div>
</template>

<style scoped>
@keyframes clicked {
  from {
    transform: scale(1.16);
    fill: theme('colors.primary.600');
    color: theme('colors.primary.600');
  }
  to {
    transform: scale(1);
    fill: theme('colors.primary.500');
    color: theme('colors.primary.500');
  }
}
</style>
